import React, { Component } from 'react';
import { ToastContainer, toast } from 'react-toastify';

import 'react-toastify/dist/ReactToastify.css';
import ForgotPasswordForm from './ForgotPasswordForm';
import axios from '../../lib/axiosInstance';
class ForgotPassword extends Component {
  constructor(props) {
    super(props);
    this.state = {
      is_notificationsent: false,
      openNotificationModal: false,
      disable_button: false,
      remember_me: false,
    };
  }
  renderNotification() {
    return (
      <>
        <ToastContainer
          position="bottom-right"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
        />
      </>
    );
  }
  async sendNotificationToUser() {
    if (this.state.email) {
      this.setState({ disable_button: true });
      let data = {
          email: this.state.email,
        },
        url = '/profiles/change-password/';
      await axios
        .post(url, data)
        .then((res) => {
          if (res.status === 200 || res.status === 201) {
            this.setState({
              is_notificationsent: true,
            });
            toast('Success! ' + res.data.success, {
              position: 'bottom-right',
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            });
          } else {
            this.setState({
              is_notificationsent: false,
            });
            toast.error('Authentication Failed! ' + res.data.detail, {
              position: 'bottom-right',
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            });
          }
          setTimeout(() => {
            this.setState({ disable_button: false });
          }, 1000);
        })
        .catch((err) => {
          let res = err.response;
          if (res.status === 422) {
            localStorage.removeItem('refresh');
            localStorage.removeItem('access');
            localStorage.removeItem('refreshTokenSetAt');
            localStorage.removeItem('accessTokenSetAt');
            this.setState({
              is_notificationsent: false,
            });
            toast.error('Authentication Failed! ' + res.data.detail, {
              position: 'bottom-right',
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            });
          } else if (res.status === 200) {
            this.setState({
              is_notificationsent: false,
            });
            toast.error('Authentication Failed! ' + res.data, {
              position: 'bottom-right',
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            });
          }
          setTimeout(() => {
            this.setState({ disable_button: false });
          }, 1000);
        });
    }
  }

  setValue(key, value) {
    if (key) {
      if (key === 'remember_me') {
        let remember_me = this.state.remember_me;
        this.setState({ remember_me: !remember_me });
      } else {
        this.setState({ [key]: value });
      }
    }
  }
  componentWillMount() {
    let device_uid = localStorage.getItem('device_uid');
    if (device_uid === undefined || device_uid === '' || device_uid === null) {
      var dateObject = new Date();
      device_uid =
        dateObject.getFullYear() +
        '' +
        dateObject.getMonth() +
        '' +
        dateObject.getDate() +
        '' +
        dateObject.getTime();
      localStorage.setItem('device_uid', device_uid);
    }
  }
  render() {
    return (
      <>
        <div className="loginscreen">
          <ForgotPasswordForm
            parentContext={this}
            sendNotificationToUser={this.sendNotificationToUser.bind(this)}
            setValue={this.setValue.bind(this)}
            appContext={this.props.parentContext}
          />
        </div>
        {this.renderNotification()}
      </>
    );
  }
}
export default ForgotPassword;
